(() => {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const visible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    const st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width > 100 && r.height > 24;
  };

  const findHeading = (text) =>
    [...document.querySelectorAll('h1, h2, h3')]
      .filter(visible)
      .find((el) => norm(el.textContent) === text);

  const findSection = (heading) => {
    if (!heading) return null;

    let node = heading;
    while (node && node !== document.body) {
      if (node.matches?.('section')) return node;
      node = node.parentElement;
    }

    return heading.closest('.shopify-section') || heading.parentElement;
  };

  const findInner = (heading, section) => {
    if (!heading || !section) return null;

    let candidate = heading.parentElement;
    let node = heading.parentElement;

    while (node && node !== section) {
      const r = node.getBoundingClientRect();
      const sr = section.getBoundingClientRect();

      if (r.width >= sr.width * 0.55 && r.height >= 120) {
        candidate = node;
      }
      node = node.parentElement;
    }

    return candidate;
  };

  const findPeerBlocks = (section) => {
    if (!section) return {};
    const kids = [...section.querySelectorAll('*')].filter((el) => {
      if (!(el instanceof HTMLElement)) return false;
      const r = el.getBoundingClientRect();
      return visible(el) && r.width > 260 && r.height > 180;
    });

    let widest = null;
    let second = null;

    for (const el of kids) {
      const area = el.getBoundingClientRect().width * el.getBoundingClientRect().height;
      if (!widest || area > (widest.getBoundingClientRect().width * widest.getBoundingClientRect().height)) {
        second = widest;
        widest = el;
      }
    }

    if (!widest) return {};

    const siblings = [...(widest.parentElement?.children || [])].filter((el) => el instanceof HTMLElement && visible(el));
    if (siblings.length >= 2) {
      return { shell: widest.parentElement, blocks: siblings };
    }

    return {};
  };

  const apply = () => {
    const formulaHeading = findHeading('formula');
    const howtoHeading = findHeading('how to apply');

    if (!formulaHeading || !howtoHeading) return;

    const formulaSection = findSection(formulaHeading);
    const howtoSection = findSection(howtoHeading);

    if (!formulaSection || !howtoSection) return;

    formulaSection.classList.add('elizna-formula-gap-v1');
    howtoSection.classList.add('elizna-howto-gap-v1');

    const formulaInner = findInner(formulaHeading, formulaSection);
    const howtoInner = findInner(howtoHeading, howtoSection);

    if (formulaInner) {
      formulaInner.classList.add('elizna-formula-gap-v1__inner');
      const peers = findPeerBlocks(formulaSection);
      if (peers.shell) peers.shell.classList.add('elizna-formula-gap-v1__grid');
      if (peers.blocks?.length >= 2) {
        peers.blocks[0].classList.add('elizna-formula-gap-v1__copy');
        peers.blocks[1].classList.add('elizna-formula-gap-v1__media');
      }
    }

    if (howtoInner) {
      howtoInner.classList.add('elizna-howto-gap-v1__inner');
      const peers = findPeerBlocks(howtoSection);
      if (peers.shell) peers.shell.classList.add('elizna-howto-gap-v1__grid');
      if (peers.blocks?.length >= 2) {
        peers.blocks[0].classList.add('elizna-howto-gap-v1__media');
        peers.blocks[1].classList.add('elizna-howto-gap-v1__copy');
      }
    }
  };

  const schedule = () => requestAnimationFrame(apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
})();
